var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25003 14.85L4.40003 11L3.1167 12.2833L8.25003 17.4166L19.25 6.41663L17.9667 5.1333L8.25003 14.85Z",
    fill: "#FFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoneWhite);
export default __webpack_public_path__ + "static/media/iconDoneWhite.bb34a9f4201401250e6a431f2d89fd35.svg";
export { ForwardRef as ReactComponent };